import React, { Fragment } from "react";
import CompareContent from "../../compare/compareContent";

const PortfolioComparison = ({ comparePortfolio }) => {
  const {
    yourDrilldown,
    yourChartOptions,
    iqcioDrilldown,
    iqcioChartOptions,
    yourTable,
    tableHead,
    optimizedTable,
  } = comparePortfolio;
  return (
    <Fragment>
      {iqcioDrilldown.length ? (
        <div id="portfolioComparison" className="tab-pane fade">
          <Fragment>
            <div className="step__title text-uppercase">
              Portfolio Comparision
            </div>
            <p>
              Presented below is the birds eye view of your portfolio and the
              recommended IQCIO model.
            </p>
          </Fragment>

          <CompareContent
            yourDrilldown={yourDrilldown}
            yourChartOptions={yourChartOptions}
            iqcioDrilldown={iqcioDrilldown}
            iqcioChartOptions={iqcioChartOptions}
            yourTable={yourTable}
            columns={tableHead}
            optimizedTable={optimizedTable}
            id={"drill11"}
            idIn={"drill_content11"}
            id2={"drill22"}
            idIn2={"drill_content22"}
          />
        </div>
      ) : null}
    </Fragment>
  );
};

export default PortfolioComparison;



// WEBPACK FOOTER //
// ./src/components/pages/dashboardComponents/PortfolioComparison/PortfolioComparison.js